/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import orderBy from 'lodash/orderBy';

import {
	set,
	setCustomer,
	setIsLoadingLoaded,
	clear,
	addDeletingLineAggId,
	removeDeletingLineAggId,
	addDeletedLineAggId,
	addErrorMessageForDeleting
} from './actions';
import {
	deleteLineAgg,
	forceDeleteLineAgg,
	fetchLinesAggs
} from '../../../api/linesaggs';
import {
	selectCustomer,
	selectErrorMessageForDeletingThisLineAgg,
	selectIsDeletedThisLineAgg,
	selectIsDeletingThisLineAgg,
	selectIsLoaded,
	selectIsLoading
} from '../selectors';
import {
	selectSortColumn,
	selectSortDirection
} from '../../LinesAggsSorting/selectors';
import { SORT_DIRECTION } from '../../LinesAggsSorting/constants';
import { getColumnBase } from '../../../../../components/LinesTable/components/Columns/utils';

function getSortAttr(sortColumn) {
	const ColumnBase = getColumnBase(sortColumn);
	return ColumnBase.SortFunction || ColumnBase.CSV_PROP;
}

function doSortItems(items, sortColumn, sortDirection = SORT_DIRECTION.ASC) {
	if (sortColumn === undefined) {
		return items;
	}
	return orderBy(items, [getSortAttr(sortColumn)], [sortDirection]);
}

const thunkSet = items => (dispatch, getState) => {
	const sortColumn = selectSortColumn(getState());
	const sortDirection = selectSortDirection(getState());
	const sortedList = doSortItems(items, sortColumn, sortDirection);
	dispatch(set({ items: sortedList }));
};

const thunkLoad = () => (dispatch, getState) => {
	const customerName = selectCustomer(getState());

	dispatch(clear());
	dispatch(setCustomer(customerName));
	dispatch(
		setIsLoadingLoaded({
			isLoading: true,
			isLoaded: false
		})
	);
	fetchLinesAggs(customerName).then(items => {
		dispatch(thunkSet(items));
		dispatch(
			setIsLoadingLoaded({
				isLoading: false,
				isLoaded: true
			})
		);
	});
};

const thunkLoadIfNotLoaded = () => (dispatch, getState) => {
	const isLoaded = selectIsLoaded(getState());
	const isLoading = selectIsLoading(getState());

	if (!isLoaded && !isLoading) {
		dispatch(thunkLoad());
	}
};

const thunkSetCustomerName = customerName => dispatch => {
	dispatch(setCustomer(customerName));
	dispatch(thunkLoad());
};

const thunkDelete = ({ id: lineAggId }, { forceDelete = false } = {}) => async (dispatch, getState) => {
	const isDeleting = selectIsDeletingThisLineAgg(getState(), lineAggId);
	const isDeleted = selectIsDeletedThisLineAgg(getState(), lineAggId);
	const hasError = selectErrorMessageForDeletingThisLineAgg(
		getState(),
		lineAggId
	);

	if (!isDeleting && !isDeleted && !hasError) {
		dispatch(addDeletingLineAggId(lineAggId));

		try {
			if (forceDelete) {
				await forceDeleteLineAgg({ id: lineAggId }); // forceDeleteLineAgg({ id: lineAggId }); // deleteLineAgg({ id: lineAggId });
			} else {
				await deleteLineAgg({ id: lineAggId });
			}

			dispatch(addDeletedLineAggId(lineAggId));
			dispatch(removeDeletingLineAggId(lineAggId));
		} catch (e) {
			dispatch(removeDeletingLineAggId(lineAggId));
			dispatch(
				addErrorMessageForDeleting(
					lineAggId,
					e?.message || 'An unknown error occured when deleting.'
				)
			);
		}
	}
};

export {
	thunkSet,
	thunkLoad,
	thunkLoadIfNotLoaded,
	thunkSetCustomerName,
	thunkDelete
};
